$(document).ready(function (e) {

    let delete_folders = [];

    function initMenu() {
        $('[data-toggle="tooltip"]').tooltip();
        // Enable sorting within .menu-droppable and .menu-folder
        $(".menu-folder").sortable({
            items: '.dragged-table',
            tolerance: 'pointer', // Improve sorting precision
            connectWith: '.menu-folder:not(.standalone-folder)', // Allow sorting between both containers
            update: function (event, ui) {
                let $menuFolder = $(this);

                // Access the sorted item
                let $sortedItem = ui.item;

                // Check if the menu-folder has any children left
                if ($menuFolder.children('.dragged-table').length === 0 && $menuFolder.hasClass('standalone-folder')) {
                    // Remove the menu-folder if it's empty
                    let folder_id = $menuFolder.attr('data-id');
                    if(folder_id && folder_id.length){
                        delete_folders.push(folder_id);
                    }
                    $menuFolder.remove();
                }

                if(!$sortedItem.find('.remove-folder-table').length){
                    $sortedItem.append(`<i class="fas remove-folder-table fa-folder-minus" data-toggle="tooltip" title="${translation.move_out_from_folder}"></i>`);
                }

                reorderItems();
            },
        });

        $(".menu-droppable").sortable({
            handle: '.handle-icon', // Use the handle icon as the sorting handle
            items: '.menu-folder',
            tolerance: 'pointer', // Improve sorting precision
            update: function (event, ui) {
                let $menuFolder = $(this);

                // Check if the menu-folder has any children left
                if ($menuFolder.children('.menu-folder').length === 0 && $menuFolder.hasClass('standalone-folder')) {
                    // Remove the menu-folder if it's empty
                    let folder_id = $menuFolder.attr('data-id');
                    if(folder_id && folder_id.length){
                        delete_folders.push(folder_id);
                        $menuFolder.remove();
                    }
                }

                reorderItems();
            },
        });
    }

    function reorderItems(){
        $('[data-toggle="tooltip"]').tooltip()
        $('.menu-folder').each(function(index, $folder){
            let $dom = $($folder),
                order = index + 1;
            $dom.attr('data-order', order);

            if(!$dom.hasClass('standalone-folder')){
                let $tables = $dom.find('.dragged-table');

                $tables.each(function(table_index, $table){
                    let $table_dom = $($table),
                        order = table_index + 1;
                    $table_dom.attr('data-order', order);
                });
            }
        });
    }

    $(".draggable-menu-table").draggable({
        revert: "invalid",
        containment: "document",
        helper: "clone",
        cursor: "move",
        appendTo: "body",
        start: function (event, ui) {
            // Get the original width of the draggable item
            let originalWidth = $(this).outerWidth();

            // Set the width of the helper element to match the original width
            ui.helper.outerWidth(originalWidth);
        }
    });

    function initSorting() {
        $('.menu-droppable, .menu-folder').droppable({
            accept: ".draggable-menu-table",
            greedy: true,
            drop: function (event, ui) {
                let droppedItem = ui.draggable,
                    table_id = $(droppedItem).attr('data-table-id');

                $(this).find('.no-folders-text').remove();
                $(this).removeClass('d-flex justify-content-center align-items-center');
                if ($(this).hasClass('menu-droppable') || $(this).hasClass('standalone-folder')) {
                    let menuDroppableDiv = $(".menu-droppable");
                    let newDiv = $(`<div><i class="handle-icon fas fa-arrows-alt"></i></div>`);
                    newDiv.addClass("menu-folder").addClass('standalone-folder card');

                    // Append the newDiv to the menuDroppableDiv
                    menuDroppableDiv.append(newDiv);

                    // Clone the droppedItem and append it to the newDiv
                    let $clone = droppedItem.clone();
                    $clone.find('.handle-icon').remove();
                    $clone.removeClass('draggable-menu-table').addClass('dragged-table');
                    $clone.append(`<i class="delete-menu-table fas fa-trash-alt" data-toggle="tooltip" title="${translation.remove_from_folder}"></i>`);
                    $clone.append(`<a class="edit-menu-table" href="/tables/${table_id}/edit?source=builder"><i class="fas fa-edit" data-toggle="tooltip" title="${translation.edit}"></i></a>`);
                    newDiv.append($clone);
                    initSorting();
                } else {
                    if (!$(this).hasClass('standalone-folder')) {
                        let $clone = droppedItem.clone();
                        $clone.find('.handle-icon').remove();
                        $clone.removeClass('draggable-menu-table').addClass('dragged-table');
                        $clone.append(`<i class="fas remove-folder-table fa-folder-minus" data-toggle="tooltip" title="${translation.move_out_from_folder}"></i>`);
                        $clone.append(`<i class="delete-menu-table fas fa-trash-alt" data-toggle="tooltip" title="${translation.remove_from_folder}"></i>`);
                        $clone.append(`<a class="edit-menu-table" href="/tables/${table_id}/edit?source=builder"><i class="fas fa-edit" data-toggle="tooltip" title="${translation.edit}"></i></a>`);
                        $(this).append($clone);
                    }
                }

                initMenu();
                reorderItems();
            }
        });
    }

    $('.update-menu').on('click', function(e){
        let folders = [];
        $('.menu-folder').each(function(index, $folder){
            let $dom = $($folder),
                order = $($dom).attr('data-order'),
                is_standalone = $dom.hasClass('standalone-folder') ? 1 : 0,
                folder_id = $($dom).attr('data-id'),
                folder_tables = [],
                table_id = '',
                folder_name = '';

            if(!$dom.hasClass('standalone-folder')){
                let $tables = $dom.find('.dragged-table');
                folder_name = $dom.find('.folder-name').val();

                $tables.each(function(table_index, $table){
                    let $table_dom = $($table),
                        table_order = $table_dom.attr('data-order'),
                        table_id = $table_dom.attr('data-table-id');

                    folder_tables.push({
                        table_order,
                        table_id
                    });
                });
            }else{
                table_id = $dom.find('.dragged-table').attr('data-table-id');
            }

            folders.push({
                folder_name,
                folder_id,
                table_id,
                folder_tables,
                is_standalone,
                order
            });
        });

        console.log(folders);

        $.ajax({
            type : 'POST',
            url : '/menu',
            data : {
                folders,
                delete_folders
            },
            success : function(res){
                delete_folders = [];
                toastr.success(translation.menu_updated);

                setTimeout(function(e){
                    window.location.reload();
                }, 700);
            }
        })
    });

    initSorting();
    initMenu();

    $('.new-menu-folder').on('click', function (e) {
        let $menu = $('.menu-droppable');
        $menu.find('.no-folders-text').remove();
        $menu.removeClass('d-flex justify-content-center align-items-center');
        let newDiv = $(`
            <div>
                <i class="handle-icon fas fa-arrows-alt"></i>
                <div class="card-header">
                    <input type="text" class="form-control w-50 folder-name" value="New Folder">
                    <i class="delete-menu-table main-folder fas fa-trash-alt"></i>
                </div>
            </div>
        `);
        newDiv.addClass("menu-folder").addClass('card').attr('data-id', '');
        // Append the newDiv to the menuDroppableDiv
        $menu.prepend(newDiv);
        initSorting();
        initMenu();
        reorderItems();
    });

    $(document).on('click', '.delete-menu-table', function(e){
        e.preventDefault();

        let $folder = $(this).parents('.menu-folder'),
            $dragged_item = $(this).parents('.dragged-table');

        if($folder.hasClass('standalone-folder') || $(this).hasClass('main-folder')){
            let folder_id = $folder.attr('data-id');

            if(folder_id !== undefined && folder_id && folder_id.length){
                delete_folders.push(folder_id);
            }
            $folder.remove();
        }else{
            $dragged_item.remove();
        }
        reorderItems();
    });


    function setFullHeight() {
        const topPosition = $('.draggable-table-list').offset().top;
        const windowHeight = $(window).height();
        $('.draggable-table-list').height(windowHeight - topPosition);
    }

    // Set the initial height
    if($('.menu-builder-page').length){
        setFullHeight();

        // If you want the div height to be updated on window resize
        $(window).resize(function() {
            setFullHeight();
        });
    }

    $('#search-menu-tables').on('keyup', function(e){
        let query = $(this).val().trim().toLowerCase(),
            $tables = $('.draggable-menu-table');

        if(query.length){
            $tables.each(function(index, table){
                let $table = $(table),
                    name = $(table).text().trim().toLowerCase();

                if (name.includes(query)) {
                    $table.removeClass('d-none');
                } else {
                    $table.addClass('d-none');
                }
            });
        }else{
            $tables.removeClass('d-none');
        }
    });

    $(document).on('click', '.sidebar-fold-name', function(e){
        let id = $(this).attr('data-folder-id'),
            $tables = $(`.folder-tables[data-folder-id="${id}"]`),
            show = 0;
        if($(this).hasClass('minimized')){
            $tables.removeClass('d-none');
            $(this).removeClass('minimized');
            $(this).find('.folder-indicator').removeClass('fa-chevron-right').addClass('fa-chevron-down');
            show = 1;
        }else{
            $tables.addClass('d-none');
            $(this).addClass('minimized');
            $(this).find('.folder-indicator').addClass('fa-chevron-right').removeClass('fa-chevron-down');
            show = 0;
        }

        $.ajax({
            url : "/toggle/menu-folder",
            type : 'POST',
            data : {
                id,
                show
            },
            success: function(res){

            }
        })
    });

    $(document).on('click', '.remove-folder-table', function(e){
        let $item = $(this).parents('.dragged-table'),
            table_id = $item.attr('data-table-id');

        let menuDroppableDiv = $(".menu-droppable");
        let newDiv = $(`<div><i class="handle-icon fas fa-arrows-alt"></i></div>`);
        newDiv.addClass("menu-folder").addClass('standalone-folder card').attr('data-id', '');
        // Append the newDiv to the menuDroppableDiv
        menuDroppableDiv.append(newDiv);

        let $clone = $item.clone();
        $clone.find('.remove-folder-table').remove();
        $clone.removeClass('draggable-menu-table').addClass('dragged-table');
        $clone.append(`<i class="delete-menu-table fas fa-trash-alt" data-toggle="tooltip" title="${translation.remove_from_folder}"></i>`);
        $clone.append(`<a class="edit-menu-table" href="/tables/${table_id}/edit?source=builder"><i class="fas fa-edit" data-toggle="tooltip" title="${translation.edit}"></i></a>`);
        newDiv.append($clone);
        initSorting();
        initMenu();
        reorderItems();
        $item.remove();
        $('[data-toggle="tooltip"]').tooltip()
    });
});